module.exports = __webpack_public_path__ + "img/microsoft.fc337c5a.svg";